// extracted by mini-css-extract-plugin
export default {"button":"main-button_button__BRlmf","input":"main-button_input__FcJbq","secondary":"main-button_secondary__7ZG57"};